import { render } from "./TestReportTOP.vue?vue&type=template&id=b0d01212&scoped=true&ts=true"
import script from "./TestReportTOP.vue?vue&type=script&lang=ts"
export * from "./TestReportTOP.vue?vue&type=script&lang=ts"

import "./TestReportTOP.vue?vue&type=style&index=0&id=b0d01212&scoped=true&lang=css"
import "./TestReportTOP.vue?vue&type=style&index=1&id=b0d01212&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0d01212"]])

export default __exports__